/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/teams": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["get_teams_for_member"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/teams/{team_slug}/projects": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["get_cli_projects_for_team"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/workos/delete_environment": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description Delete a WorkOS environment. This removes the environment from both WorkOS and the Convex database. */
        post: operations["delete_workos_environment"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/workos/disconnect_workos_team": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description Disconnect a WorkOS team from a Convex team. This is a destructive action that will prevent new WorkOS environments from being provisioned, though existing environments will continue to work. */
        post: operations["disconnect_workos_team"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/workos/available_workos_team_emails": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Get candidate email addresses to be WorkOS admins. */
        get: operations["get_available_workos_team_emails"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/deployments/{deployment_name}/has_associated_workos_team": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Check if a deployment has an associated WorkOS team */
        get: operations["get_has_associated_workos_team"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/workos/get_or_provision_workos_environment": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description Get or provision a WorkOS environment for a deployment */
        post: operations["get_or_provision_workos_environment"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/deployments/{deployment_name}/workos_environment_health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Check if the WorkOS environment associated with this deployment is still accessible */
        get: operations["get_workos_environment_health"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/teams/{team_id}/workos_invitation_eligible_emails": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Get emails eligible for WorkOS team invitation (all verified emails except those that are admin of a different WorkOS team) */
        get: operations["get_workos_invitation_eligible_emails"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/teams/{team_id}/workos_team_health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Check if the WorkOS team associated with this Convex team is still accessible */
        get: operations["get_workos_team_health"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/workos/invite_team_member": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description Invite a member to the WorkOS team associated with a Convex team */
        post: operations["invite_workos_team_member"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/workos/has_associated_workos_team": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description Check if a deployment has an associated WorkOS team */
        post: operations["has_associated_workos_team"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/workos/provision_associated_workos_team": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description Provision a WorkOS team for a Convex team */
        post: operations["provision_associated_workos_team"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/projects/{project_id}/workos_environments": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description List all WorkOS environments for a project */
        get: operations["get_project_workos_environments"];
        put?: never;
        /** @description Create a new WorkOS environment for a project */
        post: operations["provision_project_workos_environment"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/projects/{project_id}/workos_environments/{client_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Get a specific WorkOS environment for a project including credentials. This action is audited. */
        get: operations["get_project_workos_environment"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/workos/delete_project_environment": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description Delete a WorkOS environment from a project */
        post: operations["delete_project_environment"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/workos/check_project_environment_health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description Check the health of a project WorkOS environment. Returns HTTP error on failure. */
        post: operations["check_project_environment_health"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        AvailableWorkOSTeamEmailsResponse: {
            availableEmails: string[];
            usedEmails: string[];
        };
        CheckProjectEnvironmentHealthRequest: {
            /** @description WorkOS client ID */
            clientId: string;
            /**
             * Format: int64
             * @description Project ID
             */
            projectId: number;
        };
        DeleteProjectEnvironmentRequest: {
            /** @description WorkOS client ID of the environment to delete */
            clientId: string;
            /**
             * Format: int64
             * @description Project ID for the environment to delete
             */
            projectId: number;
        };
        /** @description Response for deleting a project environment - matches
         *     DeleteWorkOSEnvironmentResponse */
        DeleteProjectEnvironmentResponse: {
            workosEnvironmentId: string;
            workosEnvironmentName: string;
            workosTeamId: string;
        };
        DeleteWorkOSEnvironmentRequest: {
            /** @description Deployment name for the environment to delete */
            deploymentName: string;
        };
        DeleteWorkOSEnvironmentResponse: {
            workosEnvironmentId: string;
            workosEnvironmentName: string;
            workosTeamId: string;
        };
        DisconnectWorkOSTeamRequest: {
            /** @description Convex team ID to disconnect from WorkOS */
            teamId: components["schemas"]["TeamId"];
        };
        DisconnectWorkOSTeamResponse: {
            workosTeamId: string;
            workosTeamName: string;
        };
        GetOrProvisionEnvironmentRequest: {
            deploymentName: string;
            environmentName?: string | null;
            isProduction?: boolean | null;
        };
        /** @description Response for getting a project WorkOS environment with credentials - matches
         *     ProvisionProjectEnvironmentResponse pattern with workos_ prefix */
        GetProjectEnvironmentResponse: {
            isProduction: boolean;
            /** @description The user-provided environment name (e.g., "staging", "development") */
            userEnvironmentName: string;
            workosApiKey: string;
            workosClientId: string;
            workosEnvironmentId: string;
            workosEnvironmentName: string;
        };
        GetProjectEnvironmentsResponse: {
            environments: components["schemas"]["ProjectEnvironmentSummary"][];
        };
        HasAssociatedWorkOSTeamRequest: {
            deploymentName: string;
        };
        HasAssociatedWorkOSTeamResponse: {
            /** @description Email of Convex team member who created the WorkOS account.
             *     This field should always be present when has_associated_workos_team is
             *     true. */
            adminConvexEmail?: string | null;
            /** @description Email address used to provision the WorkOS account. This field should
             *     always be present if has_associated_workos_team is true. */
            adminEmail?: string | null;
            /** @description Name of Convex team member who created the WorkOS account.
             *     This field is optional even when has_associated_workos_team is true. */
            adminName?: string | null;
            hasAssociatedWorkosTeam: boolean;
            teamId: components["schemas"]["TeamId"];
        };
        InvitationEligibleEmailsResponse: {
            /** @description The admin email used to create this team's WorkOS account (always
             *     eligible for re-invitation) */
            adminEmail?: string | null;
            eligibleEmails: string[];
        };
        InviteWorkOSTeamMemberRequest: {
            /** @description Email address to invite to the WorkOS team,
             *     must be a verified email address associated with the user's account */
            email: string;
            /** @description Convex team ID that has an associated WorkOS team */
            teamId: components["schemas"]["TeamId"];
        };
        InviteWorkOSTeamMemberResponse: {
            email: string;
            roleSlug: string;
        };
        /** @enum {string} */
        ManagedBy: "vercel";
        /** Format: int64 */
        MemberId: number;
        ProjectDetails: {
            /** Format: int64 */
            createTime: number;
            devDeploymentName?: string | null;
            id: components["schemas"]["ProjectId"];
            isDemo: boolean;
            name: components["schemas"]["ProjectName"];
            prodDeploymentName?: string | null;
            slug: components["schemas"]["ProjectSlug"];
            teamId: components["schemas"]["TeamId"];
        };
        /** @description Summary of a project WorkOS environment for list responses - slimmer than
         *     full environment details, uses workos_ prefix for consistency with
         *     deployment */
        ProjectEnvironmentSummary: {
            isProduction: boolean;
            /** @description The user-provided environment name (e.g., "staging", "development") */
            userEnvironmentName: string;
            workosClientId: string;
            workosEnvironmentId: string;
            workosEnvironmentName: string;
        };
        /** Format: int64 */
        ProjectId: number;
        ProjectName: string;
        ProjectSlug: string;
        ProvisionEnvironmentResponse: {
            apiKey: string;
            clientId: string;
            environmentId: string;
            environmentName: string;
            newlyProvisioned: boolean;
        };
        ProvisionProjectEnvironmentRequest: {
            environmentName: string;
            isProduction?: boolean | null;
        };
        /** @description Response for provisioning a project WorkOS environment - matches
         *     ProvisionEnvironmentResponse pattern with workos_ prefix for consistency */
        ProvisionProjectEnvironmentResponse: {
            newlyProvisioned: boolean;
            /** @description The user-provided environment name (e.g., "staging", "development") */
            userEnvironmentName: string;
            workosApiKey: string;
            workosClientId: string;
            workosEnvironmentId: string;
            workosEnvironmentName: string;
        };
        ProvisionWorkOSTeamRequest: {
            /** @description Email address to use for the WorkOS team admin,
             *     must be a verified email address associated with the user's account */
            email: string;
            /** @description Convex team ID, no WorkOS team exists at this point */
            teamId: components["schemas"]["TeamId"];
        };
        ProvisionWorkOSTeamResponse: {
            adminEmail: string;
            workosTeamId: string;
            workosTeamName: string;
        };
        ReferralCode: string;
        RegionName: string;
        /** Format: int64 */
        TeamId: number;
        TeamName: string;
        TeamResponse: {
            creator?: null | components["schemas"]["MemberId"];
            defaultRegion?: null | components["schemas"]["RegionName"];
            id: components["schemas"]["TeamId"];
            managedBy?: null | components["schemas"]["ManagedBy"];
            managedByUrl?: string | null;
            name: components["schemas"]["TeamName"];
            referralCode: components["schemas"]["ReferralCode"];
            referredBy?: null | components["schemas"]["TeamId"];
            slug: components["schemas"]["TeamSlug"];
            ssoLoginId?: string | null;
            suspended: boolean;
        };
        TeamSlug: string;
        WorkOSEnvironmentHealthResponse: {
            clientId: string;
            id: string;
            name: string;
        };
        /** @enum {string} */
        WorkOSProductionState: "active" | "inactive";
        WorkOSTeamHealthResponse: {
            teamInfo?: null | components["schemas"]["WorkOSTeamInfo"];
            /** @description Whether a WorkOS team has been provisioned for this Convex team */
            teamProvisioned: boolean;
        };
        WorkOSTeamInfo: {
            id: string;
            name: string;
            productionState: components["schemas"]["WorkOSProductionState"];
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type AvailableWorkOsTeamEmailsResponse = components['schemas']['AvailableWorkOSTeamEmailsResponse'];
export type CheckProjectEnvironmentHealthRequest = components['schemas']['CheckProjectEnvironmentHealthRequest'];
export type DeleteProjectEnvironmentRequest = components['schemas']['DeleteProjectEnvironmentRequest'];
export type DeleteProjectEnvironmentResponse = components['schemas']['DeleteProjectEnvironmentResponse'];
export type DeleteWorkOsEnvironmentRequest = components['schemas']['DeleteWorkOSEnvironmentRequest'];
export type DeleteWorkOsEnvironmentResponse = components['schemas']['DeleteWorkOSEnvironmentResponse'];
export type DisconnectWorkOsTeamRequest = components['schemas']['DisconnectWorkOSTeamRequest'];
export type DisconnectWorkOsTeamResponse = components['schemas']['DisconnectWorkOSTeamResponse'];
export type GetOrProvisionEnvironmentRequest = components['schemas']['GetOrProvisionEnvironmentRequest'];
export type GetProjectEnvironmentResponse = components['schemas']['GetProjectEnvironmentResponse'];
export type GetProjectEnvironmentsResponse = components['schemas']['GetProjectEnvironmentsResponse'];
export type HasAssociatedWorkOsTeamRequest = components['schemas']['HasAssociatedWorkOSTeamRequest'];
export type HasAssociatedWorkOsTeamResponse = components['schemas']['HasAssociatedWorkOSTeamResponse'];
export type InvitationEligibleEmailsResponse = components['schemas']['InvitationEligibleEmailsResponse'];
export type InviteWorkOsTeamMemberRequest = components['schemas']['InviteWorkOSTeamMemberRequest'];
export type InviteWorkOsTeamMemberResponse = components['schemas']['InviteWorkOSTeamMemberResponse'];
export type ManagedBy = components['schemas']['ManagedBy'];
export type MemberId = components['schemas']['MemberId'];
export type ProjectDetails = components['schemas']['ProjectDetails'];
export type ProjectEnvironmentSummary = components['schemas']['ProjectEnvironmentSummary'];
export type ProjectId = components['schemas']['ProjectId'];
export type ProjectName = components['schemas']['ProjectName'];
export type ProjectSlug = components['schemas']['ProjectSlug'];
export type ProvisionEnvironmentResponse = components['schemas']['ProvisionEnvironmentResponse'];
export type ProvisionProjectEnvironmentRequest = components['schemas']['ProvisionProjectEnvironmentRequest'];
export type ProvisionProjectEnvironmentResponse = components['schemas']['ProvisionProjectEnvironmentResponse'];
export type ProvisionWorkOsTeamRequest = components['schemas']['ProvisionWorkOSTeamRequest'];
export type ProvisionWorkOsTeamResponse = components['schemas']['ProvisionWorkOSTeamResponse'];
export type ReferralCode = components['schemas']['ReferralCode'];
export type RegionName = components['schemas']['RegionName'];
export type TeamId = components['schemas']['TeamId'];
export type TeamName = components['schemas']['TeamName'];
export type TeamResponse = components['schemas']['TeamResponse'];
export type TeamSlug = components['schemas']['TeamSlug'];
export type WorkOsEnvironmentHealthResponse = components['schemas']['WorkOSEnvironmentHealthResponse'];
export type WorkOsProductionState = components['schemas']['WorkOSProductionState'];
export type WorkOsTeamHealthResponse = components['schemas']['WorkOSTeamHealthResponse'];
export type WorkOsTeamInfo = components['schemas']['WorkOSTeamInfo'];
export type $defs = Record<string, never>;
export interface operations {
    get_teams_for_member: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TeamResponse"][];
                };
            };
        };
    };
    get_cli_projects_for_team: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Team slug identifier */
                team_slug: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProjectDetails"][];
                };
            };
        };
    };
    delete_workos_environment: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DeleteWorkOSEnvironmentRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DeleteWorkOSEnvironmentResponse"];
                };
            };
        };
    };
    disconnect_workos_team: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DisconnectWorkOSTeamRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DisconnectWorkOSTeamResponse"];
                };
            };
        };
    };
    get_available_workos_team_emails: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AvailableWorkOSTeamEmailsResponse"];
                };
            };
        };
    };
    get_has_associated_workos_team: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Deployment name */
                deployment_name: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HasAssociatedWorkOSTeamResponse"];
                };
            };
        };
    };
    get_or_provision_workos_environment: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["GetOrProvisionEnvironmentRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProvisionEnvironmentResponse"];
                };
            };
        };
    };
    get_workos_environment_health: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Deployment name */
                deployment_name: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["WorkOSEnvironmentHealthResponse"];
                };
            };
        };
    };
    get_workos_invitation_eligible_emails: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Convex team ID */
                team_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["InvitationEligibleEmailsResponse"];
                };
            };
        };
    };
    get_workos_team_health: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Convex team ID */
                team_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["WorkOSTeamHealthResponse"];
                };
            };
        };
    };
    invite_workos_team_member: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["InviteWorkOSTeamMemberRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["InviteWorkOSTeamMemberResponse"];
                };
            };
        };
    };
    has_associated_workos_team: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["HasAssociatedWorkOSTeamRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HasAssociatedWorkOSTeamResponse"];
                };
            };
        };
    };
    provision_associated_workos_team: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ProvisionWorkOSTeamRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProvisionWorkOSTeamResponse"];
                };
            };
        };
    };
    get_project_workos_environments: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                project_id: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetProjectEnvironmentsResponse"];
                };
            };
        };
    };
    provision_project_workos_environment: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                project_id: number;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ProvisionProjectEnvironmentRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProvisionProjectEnvironmentResponse"];
                };
            };
        };
    };
    get_project_workos_environment: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                project_id: number;
                client_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetProjectEnvironmentResponse"];
                };
            };
        };
    };
    delete_project_environment: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DeleteProjectEnvironmentRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DeleteProjectEnvironmentResponse"];
                };
            };
        };
    };
    check_project_environment_health: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CheckProjectEnvironmentHealthRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["WorkOSEnvironmentHealthResponse"];
                };
            };
        };
    };
}
